var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.138 2.19526C15.3983 2.45561 15.3983 2.87772 15.138 3.13807L8.47132 9.80474C8.21097 10.0651 7.78886 10.0651 7.52851 9.80474L5.52851 7.80474C5.26816 7.54439 5.26816 7.12228 5.52851 6.86193C5.78886 6.60158 6.21097 6.60158 6.47132 6.86193L7.99992 8.39052L14.1952 2.19526C14.4555 1.93491 14.8776 1.93491 15.138 2.19526Z",
    fill: "#FB7B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 2.66665C3.15644 2.66665 2.98687 2.73688 2.86185 2.86191C2.73682 2.98693 2.66659 3.1565 2.66659 3.33331V12.6666C2.66659 12.8435 2.73682 13.013 2.86185 13.1381C2.98687 13.2631 3.15644 13.3333 3.33325 13.3333H12.6666C12.8434 13.3333 13.013 13.2631 13.138 13.1381C13.263 13.013 13.3333 12.8435 13.3333 12.6666V7.99998C13.3333 7.63179 13.6317 7.33331 13.9999 7.33331C14.3681 7.33331 14.6666 7.63179 14.6666 7.99998V12.6666C14.6666 13.1971 14.4559 13.7058 14.0808 14.0809C13.7057 14.4559 13.197 14.6666 12.6666 14.6666H3.33325C2.80282 14.6666 2.29411 14.4559 1.91904 14.0809C1.54397 13.7058 1.33325 13.1971 1.33325 12.6666V3.33331C1.33325 2.80288 1.54397 2.29417 1.91904 1.9191C2.29411 1.54403 2.80282 1.33331 3.33325 1.33331H10.6666C11.0348 1.33331 11.3333 1.63179 11.3333 1.99998C11.3333 2.36817 11.0348 2.66665 10.6666 2.66665H3.33325Z",
    fill: "#FB7B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIcon);
export default __webpack_public_path__ + "static/media/approve-icon.7e6c790f2aef4f36a5aad4448c7c2dfd.svg";
export { ForwardRef as ReactComponent };